import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import styles from './ActivityLoading.module.css'

function ActivityRowSkeleton() {
  return (
    <div className="d-flex flex-items-center gap-2 p-1">
      <SkeletonBox height="16px" width="16px" />
      <SkeletonText size="bodySmall" className={styles.skeletonText} />
    </div>
  )
}

export function ActivityLoading() {
  return (
    <div className="d-flex flex-column">
      <ActivityRowSkeleton />
      <ActivityRowSkeleton />
      <ActivityRowSkeleton />
    </div>
  )
}
